import { useHistory } from "react-router-dom";
import { broadcastPaths } from "@/react/helpers/urlHelpers/broadcastPaths";
import { useIsEmailHubStatusEnabled } from "@/react/hooks/useIsEmailHubStatus";
import { useCreateFromSource } from "../shared/Emails/useCreateFromSource";

export const useConvertPostToBroadcast = () => {
  const history = useHistory();
  const { mutate: convertFromSource, ...rest } = useCreateFromSource();
  const isEmailHubEnabled = useIsEmailHubStatusEnabled();

  const handleShareViaBroadcast = ({
    postId,
    onSuccess,
  }: {
    postId: number;
    onSuccess?: () => void;
  }) => {
    if (!isEmailHubEnabled) {
      history.push(broadcastPaths.list());
      onSuccess?.();
      return;
    }

    convertFromSource(
      {
        source_content_id: postId,
        source_content_type: "Post",
      },
      {
        onSuccess: data => {
          onSuccess?.();
          history.push(broadcastPaths.edit({ broadcastId: data.broadcast.id }));
        },
      },
    );
  };

  return {
    onShareViaBroadcast: handleShareViaBroadcast,
    ...rest,
  };
};
